import AuthService from '../services/AuthService';
import {hashHistory} from 'react-router';
import LoginConstants from '../constants/LoginConstants';
import ErrorsConstants from '../constants/ErrorsConstants';
import ErrorHandler from '../helpers/ErrorHandler';
import store from 'store';

export default {
  authUser: (email,password) => dispatch =>  {
    dispatch({type: 'ON_BUSY'});
    AuthService.login(email, password).then((response) => {
      dispatch({type: 'OFF_BUSY'});
      const user = {
        id: response.merchant.id,
        jwt: response.merchant.authentication_token
      };
      var userStore = store.get('userRf1');
      dispatch({type: LoginConstants.LOGIN_USER, payload: user});
      if (userStore) {
        if (userStore.jwt !== user.jwt ) {
          store.set('userRf1', user);
        }
      } else {
        store.set('userRf1', user);
      }
      hashHistory.push('/dashboard');
    }, (err) => {
      if (err.status === 401) {
        dispatch({type: ErrorsConstants.INCORRECT_ENTITIES, payload: 'Incorrect username or password. Please try again'});
      } else {
        ErrorHandler(err)
      }
      dispatch({type: 'OFF_BUSY'});
    });
  },
  logoutUser: () => dispatch => {
    store.remove('userRf1');
    dispatch({type: LoginConstants.LOGOUT_USER});
    hashHistory.push('/login');
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/AuthorizationAction.js
 **/